import { useState, useCallback } from 'react'
import { useGo, useInvalidate } from '@refinedev/core'

export const usePublisherRequestDrawerNav = () => {
  const go = useGo()
  const invalidate = useInvalidate()

  const onDrawerClose = useCallback(() => {
    go({
      to: '/request',
      type: 'replace',
    })
  }, [go])

  const handleReviewSuccess = useCallback(() => {
    invalidate({
      resource: 'publisher-request',
      invalidates: ['list', 'detail'],
    })
  }, [invalidate])

  return { onDrawerClose, handleReviewSuccess }
}

export const usePublisherRequestDetailsPanel = (initiallyOpen: boolean) => {
  const [detailsOpen, setDetailsOpen] = useState(initiallyOpen)

  const toggleDetails = useCallback(() => {
    setDetailsOpen(prev => !prev)
  }, [])

  return { detailsOpen, toggleDetails }
}
